// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import * as firebase from 'firebase/app'
import VueParticles from 'vue-particles'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'

// Add the Firebase services that you want to use
// eslint-disable-next-line no-unused-vars
/* eslint-disable */
import 'firebase/auth'
import 'firebase/firestore'
window.axios = require('axios');

Vue.use(VueParticles)
// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
var firebaseConfig = {
  apiKey: 'AIzaSyDpVKDZhXi6LwFPNtykn4Bjpxsg36AsubA',
  authDomain: 'tolrenfrank2020.firebaseapp.com',
  databaseURL: 'https://tolrenfrank2020.firebaseio.com',
  projectId: 'tolrenfrank2020',
  storageBucket: 'tolrenfrank2020.appspot.com',
  messagingSenderId: '528925256549',
  appId: '1:528925256549:web:4d2071b27bed498a590f8c',
  measurementId: 'G-DLDMGFW49Z'
}

// Initialize Firebase
firebase.initializeApp(firebaseConfig)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js